import { render, staticRenderFns } from "./DashItem.vue?vue&type=template&id=3048f061"
import script from "./DashItem.vue?vue&type=script&lang=js"
export * from "./DashItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports